import { createFileRoute, notFound } from "@tanstack/react-router";
import { getPage } from "@/content/pages";
import { MarkdownPage } from "@/components/MarkdownPage";
import { breadcrumbScript, pageMetaTitle, SITE_URL } from "@/lib/seo";

const PAGE_KEY = "/seo/trades/builders";

export const Route = createFileRoute("/seo/trades/builders")({
  loader: () => {
    const page = getPage(PAGE_KEY);
    if (!page) throw notFound();
    return page;
  },
  head: ({ loaderData }) => ({
    meta: loaderData
      ? [
          { title: pageMetaTitle(PAGE_KEY, loaderData.title) },
          { name: "description", content: loaderData.description },
          { property: "og:title", content: loaderData.title },
          { property: "og:description", content: loaderData.description },
          { property: "og:url", content: "https://www.phil-carr.co.uk/seo/trades/builders" },
        ]
      : [],
    links: [{ rel: "canonical", href: "https://www.phil-carr.co.uk/seo/trades/builders" }],
    scripts: loaderData
      ? [
          breadcrumbScript([
            { name: "Home", url: `${SITE_URL}/` },
            { name: "SEO", url: `${SITE_URL}/seo` },
            { name: "SEO for Trades", url: `${SITE_URL}/seo/trades` },
            { name: loaderData.title, url: `${SITE_URL}${PAGE_KEY}` },
          ]),
        ]
      : [],
  }),
  notFoundComponent: () => (
    <div className="container mx-auto max-w-3xl px-6 py-24 text-center">
      <h1 className="font-display text-4xl">Page not found</h1>
    </div>
  ),
  errorComponent: ({ error }) => (
    <div className="container mx-auto max-w-3xl px-6 py-24 text-center">
      <h1 className="font-display text-3xl">Something went wrong</h1>
      <p className="mt-3 text-muted-foreground">{error.message}</p>
    </div>
  ),
  component: Page,
});

function Page() {
  const page = Route.useLoaderData();
  return (
    <MarkdownPage
      body={page.body}
      pageContext={page.title}
      relatedSlugs={[
        "how-builders-can-get-more-quote-requests-from-google",
        "seo-mistakes-that-cost-builders-local-leads",
        "barnsley-seo-for-builders-how-to-turn-google-searches-into-quote-requests",
      ]}
    />
  );
}
